import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Toaster.css';

toast.configure(1000);
export const notifyOk = (message, key = null) => {
  return (
    toast.success(message),
    {
      toastId: key,
    }
  );
};
export const notifyError = (message, key = null, toastOptions = {}) => {
  return (
    toast.error(message, toastOptions),
    {
      toastId: key,
    }
  );
};

// Shows the backend's own error message(s) as-is (e.g. "Email id is already
// in use", or a list of class-validator messages), instead of a generic
// "Error doing X: <status code / axios message>" wrapper. class-validator
// errors come back as an array — one toast per message, matching how
// upp-portal itself surfaces these same responses.
export const notifyApiError = (error, fallback = 'Something went wrong. Please try again.') => {
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) {
    message.forEach((item) => notifyError(item));
  } else if (typeof message === 'string' && message) {
    notifyError(message);
  } else {
    notifyError(error?.message || fallback);
  }
};
